import React, { ReactNode } from "react";
import styled from "styled-components";
import { default as TrailheadIcon } from "@trailhead/icons";
import {
  FlexColumnContainer,
  VerticalDivider,
} from "../layout/StyledComponents";
import { breakpoints, Text, Icon } from "@trailhead/asurion-ui";

type StyledComponentsProps = Partial<ListItemNavProps>;

interface ListItemNavProps {
  index: number;
  viewed: boolean;
  last: boolean;
  isNext: boolean;
  onClick: (index: number, analyticProps: Record<string, unknown>) => void;
  icon: ReactNode;
  subText?: string;
  titleText?: string;
  guideType?: string;
}

const ListItemNavContainer = styled.div<StyledComponentsProps>`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: stretch;
  justify-content: space-around;
  max-height: 650px;
  width: 100%;
  padding-bottom: 16px;
  cursor: pointer;
  gap: 16px;
`;

const ContentTextContainer = styled(FlexColumnContainer)`
  align-items: flex-start;
  text-align: left;
  flex: 0 0 70%;

  ${breakpoints.md} {
    flex: 0 0 80%;
  }
`;

const TitleText = styled(Text)`
  margin: 0;
  margin-bottom: 7px;
`;

const SubText = styled(Text)`
  margin: 0;
`;

const TimelineContainer = styled(FlexColumnContainer)`
  justify-content: flex-start;
  align-items: center;
  min-height: 52px;
  max-width: 24px;
  margin: 0 10px;
  z-index: 10;
`;

const Checkmark = styled.div`
  flex-grow: 0;
`;

const VerticalLine = styled(VerticalDivider)`
  background-color: #000000;
  flex: 1;
  margin-bottom: -21px;
  margin-top: -7px;
`;

const Chevron = styled.div`
  margin-right: 12px;
  display: flex;
  align-items: center;
`;

const TimelineImage = styled.div`
  padding-top: 4;
  width: 40px;
  height: 40px;
`;

export const ListItemNav = ({
  index,
  viewed,
  subText,
  titleText,
  last,
  isNext,
  onClick,
  icon,
}: ListItemNavProps) => {
  const generateTimeline = () => (
    <TimelineContainer>
      <Checkmark>
        {(viewed && <TrailheadIcon name="CheckedCircle" />) || (
          <TrailheadIcon name="UncheckedCircle" />
        )}
      </Checkmark>
      {(!last && <VerticalLine />) || <TimelineImage>{icon}</TimelineImage>}
    </TimelineContainer>
  );

  return (
    <ListItemNavContainer
      onClick={() => onClick(index, { titleText, subText })}
      data-testid="list-item-nav"
      isNext={isNext}
    >
      {generateTimeline()}
      <ContentTextContainer>
        {titleText && (
          <TitleText
            size={2}
            weight={"heavy"}
            dangerouslySetInnerHTML={{
              __html: titleText,
            }}
          />
        )}
        {subText && (
          <SubText
            size={1}
            dangerouslySetInnerHTML={{
              __html: subText,
            }}
          />
        )}
      </ContentTextContainer>
      <Chevron>
        <Icon size="large" src="ChevronRight" />
      </Chevron>
    </ListItemNavContainer>
  );
};
